/* eslint-disable */
import { Button } from '@mui/material';
import { CloseIcon } from 'src/icons';
import React, { useState, useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useJobs } from 'src/hooks/query/jobs';
import { useMailMergeTemplate } from 'src/hooks/query/mailMerge';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import RHFEditor from '../elements/Editor/RHFEditor';
import RHFEmailsChips from '../elements/EmailsChips/RHFEmailsChips';
import RHFInput from '../elements/Input/RHFInput';
import { CandidateMailStatus } from './types';

export interface MailerFormValues {
  to: Array<string>;
  cc?: Array<string> | null;
  subject: string;
  content: string;
}

const validationSchema = yup.object().shape({
  to: yup.array(yup.string().email()).required('Must have at least 1 email'),
  cc: yup.array(yup.string().email()).optional(),
  subject: yup.string().required('subject required').min(1, 'Subject required'),
  content: yup.string().required('email content required'),
});

interface MailerProps {
  onSubmit: (data: MailerFormValues) => void;
  onCancel: () => void;
  loading: boolean;
  defaultValues?: MailerFormValues | undefined;
  title?: string;
}

const Mailer = function Mailer(props: MailerProps) {
  const {
    onSubmit,
    defaultValues,
    onCancel,
    title,
  } = props;

  const resolver = useYupValidationResolver(validationSchema);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);

  const { templateFetching, getTemplate } = useMailMergeTemplate();
  const methods = useForm<MailerFormValues>({
    defaultValues,
    resolver,
  });

  const {
    handleSubmit,
  } = methods;

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues]);

  const submitHandler: SubmitHandler<MailerFormValues> = async (data) => {
    // console.log('data', data);
    setDisableSubmit(true);
    await onSubmit(data);
    setDisableSubmit(false);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)} className="bg-white  p-10 flex gap-8 justify-center items-center flex-col">
        {title && (
          <div className="flex justify-center items-center w-full text-[#28364C] font-medium text-base">
            {title}
          </div>
        )}
        
        <div className="flex w-full p-4 flex-col gap-10">
          <div className="w-full flex-shrink-0">
            <RHFEmailsChips
              control={methods.control}
              name="to"
              label="To"
              placeholder="Enter emails"
            />
          </div>
          {
            (title !== CandidateMailStatus.REJECTED) 
            && <div className="w-full flex-shrink-0">
            <RHFEmailsChips
              control={methods.control}
              name="cc"
              label="cc"
              placeholder="Enter emails"
            />
          </div>
          }
          <div className="w-full flex-shrink-0">
            <RHFInput
              control={methods.control}
              name="subject"
              label="Subject"
              placeholder="Subject"
              disabled={templateFetching}
            />
          </div>
          <div className="w-full min-h-[200px] flex-shrink-0">
            <RHFEditor
              control={methods.control}
              name="content"
              disabled={templateFetching}
            />
          </div>
        </div>
        <div className="w-full flex  gap-2 ">
          <Button variant="contained" type="submit" size="small" className="font-medium rounded-full" disabled={disableSubmit}>Send</Button>
          <Button variant="outlined" size="small" className="font-medium rounded-full" onClick={onCancel} disabled={disableSubmit}>Cancel</Button>
        </div>
        <div
          className="absolute right-2 top-2"
          onClick={onCancel}
        >
          <CloseIcon className="cursor-pointer" />
        </div>
      </form>
    </FormProvider>
  );
};

Mailer.defaultProps = {
  title: '',
};

Mailer.propTypes = {

};

export default Mailer;
